import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useAlert } from '../components/GlobalAlert';
import './OAuthCallback.css';

const OAuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { showAlert } = useAlert();
  const [status, setStatus] = useState('processing');
  const [message, setMessage] = useState('กำลังประมวลผลการล็อกอิน...');

  useEffect(() => {
    const handleOAuthCallback = async () => {
      try {
        // ตรวจสอบ URL parameters
        const urlParams = new URLSearchParams(location.search);
        const error = urlParams.get('error');
        const token = urlParams.get('token');
        const user = urlParams.get('user');
        
        if (error) {
          setStatus('error');
          setMessage(`เกิดข้อผิดพลาด: ${error}`);
          showAlert(`การล็อกอินล้มเหลว: ${error}`, 'error');
          setTimeout(() => navigate('/login'), 3000);
          return;
        }

        if (!token || !user) {
          setStatus('error');
          setMessage('ไม่พบข้อมูลการล็อกอิน');
          showAlert('การล็อกอินล้มเหลว: ไม่พบข้อมูลการล็อกอิน', 'error');
          setTimeout(() => navigate('/login'), 3000);
          return;
        }

        // ตรวจสอบว่าเป็น Google หรือ LINE OAuth
        const isGoogle = location.pathname.includes('google');
        const isLine = location.pathname.includes('line');
        
        if (!isGoogle && !isLine) {
          setStatus('error');
          setMessage('ไม่รู้จัก OAuth provider');
          showAlert('การล็อกอินล้มเหลว: ไม่รู้จัก OAuth provider', 'error');
          setTimeout(() => navigate('/login'), 3000);
          return;
        }

        setMessage(`กำลังยืนยันการล็อกอินผ่าน ${isGoogle ? 'Google' : 'LINE'}...`);

        try {
          // Parse user data
          const userData = JSON.parse(decodeURIComponent(user));
          
          // บันทึกข้อมูลลง localStorage
          localStorage.setItem('token', token);
          localStorage.setItem('user', JSON.stringify(userData));
          
          setStatus('success');
          setMessage('ล็อกอินสำเร็จ! กำลังเปลี่ยนเส้นทาง...');
          showAlert(`ล็อกอินผ่าน ${isGoogle ? 'Google' : 'LINE'} สำเร็จ!`, 'success');
          
          // รีเฟรชหน้าเพื่อให้ AuthContext อัปเดต
          setTimeout(() => {
            window.location.href = '/dashboard';
          }, 1500);
        } catch (parseError) {
          throw new Error('ข้อมูลผู้ใช้ไม่ถูกต้อง');
        }

      } catch (error) {
        console.error('OAuth callback error:', error);
        setStatus('error');
        setMessage(`เกิดข้อผิดพลาด: ${error.message}`);
        showAlert(`การล็อกอินล้มเหลว: ${error.message}`, 'error');
        setTimeout(() => navigate('/login'), 3000);
      }
    };

    handleOAuthCallback();
  }, [location, navigate, showAlert]);

  return (
    <div className="oauth-callback">
      <div className="oauth-callback-container">
        <div className={`oauth-callback-icon ${status}`}>
          {status === 'processing' && '⏳'}
          {status === 'success' && '✅'}
          {status === 'error' && '❌'}
        </div>
        
        <h1 className="oauth-callback-title">
          {status === 'processing' && 'กำลังประมวลผล...'}
          {status === 'success' && 'ล็อกอินสำเร็จ!'}
          {status === 'error' && 'เกิดข้อผิดพลาด'}
        </h1>
        
        <p className="oauth-callback-message">{message}</p>
        
        {status === 'processing' && (
          <div className="oauth-callback-spinner">
            <div className="spinner"></div>
          </div>
        )}
        
        {status === 'error' && (
          <button 
            className="oauth-callback-retry-btn"
            onClick={() => navigate('/login')}
          >
            กลับไปหน้า Login
          </button>
        )}
      </div>
    </div>
  );
};

export default OAuthCallback;
